import { render } from "./insertViewBatchTrim.vue?vue&type=template&id=725067e8&scoped=true"
import script from "./insertViewBatchTrim.vue?vue&type=script&lang=js"
export * from "./insertViewBatchTrim.vue?vue&type=script&lang=js"

import "./insertViewBatchTrim.vue?vue&type=style&index=0&id=725067e8&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725067e8"]])

export default __exports__